export default () => {
  const autoplayWrappers = document.querySelectorAll('[data-autoplay]');

  const init = el => {
    const isCloseToHero = el.dataset.closeToHero
    const placeholder = el.querySelector('.autoplay__placeholder')
    const iframe = el.querySelector('[data-autoplay-iframe]')

    let observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const { isIntersecting } = entry;
          if(isIntersecting){
            if(placeholder) placeholder.style.display = "none";
            iframe.src = iframe.dataset.src
            observer.unobserve(iframe);
          }
        });
      },
      { rootMargin: isCloseToHero ? '100px' :'40px', threshold: 0.1 }
    );
    observer.observe(iframe);
  }

  autoplayWrappers.forEach(el => init(el))
}